import { c as _c } from "react/compiler-runtime";
import { EntityName } from 'record-it-time-common/EntityName';
import { TimeTrackingActivityCompilation } from '../../../classes/entities/TimeTrackingActivityCompilation/timeTrackingActivityCompilationTypes';
import { useEntityRepository } from '../../../hooks/entity/useEntityRepository';
import { useConfigureBreadcrumbsWithBuilder } from '../../../hooks/misc/useConfigureBreadcrumbsWithBuilder';
export function useConfigureTimeTrackingActivityAdminPageBreadcrumbs(compilation, parentActivityId) {
  const $ = _c(5);
  const repository = useEntityRepository(EntityName.TimeTrackingActivity);
  let t0;
  if ($[0] !== compilation.id || $[1] !== compilation.ownerUserGroupId || $[2] !== parentActivityId || $[3] !== repository) {
    t0 = builder => {
      builder.addHomePage().addTimeTrackingActivityCompilationAdminPage(compilation.ownerUserGroupId).addTimeTrackingActivityAdminPage(compilation.id, null);
      const path = parentActivityId ? repository.getPath(parentActivityId) : [];
      for (const activity of path) {
        if (activity) {
          builder.addTimeTrackingActivityAdminPage(compilation.id, activity.id);
        }
      }
    };
    $[0] = compilation.id;
    $[1] = compilation.ownerUserGroupId;
    $[2] = parentActivityId;
    $[3] = repository;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  useConfigureBreadcrumbsWithBuilder(t0);
}